<template>
  <div class="mini-grid">
    <div>
      <el-button type="primary" @click="printpage()">打印</el-button>
      <!-- <el-button type="success" @click="start_page()">上一页</el-button>
      <el-button type="success" @click="end_page()">下一页</el-button> -->
      <el-button type="danger" @click="close()">关闭</el-button>
    </div>
  </div>
</template>

<script>

export default {
  components: { 
  },
  name: "print_zlfymxd",
  data() {
    return {
      HTH:new URLSearchParams(window.location.search).get('HTH'),
      NY:new URLSearchParams(window.location.search).get('NY'),
      user:JSON.parse(sessionStorage.currentUser)
    };
  },
  methods: {
    close(){
        window.close();
    },
    printpage(){//打印
      let printStr = "<html><head><meta http-equiv='Content-Type' content='text/html;charset=utf-8'></head><body >";
      let content = "";
      let sprnstr = "<!--startprint1-->";//设置打印开始区域
      let eprnstr = "<!--endprint1-->";//设置打印结束区域
      content = content+sprnstr ;//加载打印头

      //纵向：@page { size: portrait; }
      //横向：@page { size: landscape; }
      let sss= "<style"+" type="+"text/css"+">"+"@page { size: auto;margin-top: 5mm;margin-left: 10mm;}"+"body{ zoom:70%;padding: 0px 32px; }"+"</style>" ;
      content+=sss;
      if($("#ipt_count").val()==0){
          $("#ipt_count").val(1);
      }
      let num=$("#ipt_count").val();//打印的页数
      //判断是否只有1页要打印
      if(num==1){
          //只打印一页，是否打印子表
          if( $("#div_box").val()==0 ){
              content+=document.getElementById('model0').innerHTML;
              //let str = document.getElementById('div_model0').innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
              //content+=str;
              content+=document.getElementById('model2').innerHTML;
          }else{
              content+=document.getElementById('model0').innerHTML;
              let str = document.getElementById('div_model0').innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
              content+=str;
              content+=document.getElementById('model2').innerHTML;
          }

      }else{//不止要打印一份
          for (let i=0;i<num;i++){
              content+=document.getElementById('model0').innerHTML;
              let str = document.getElementById('div_model'+i).innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
              content+=str;
              if( (i+1)%2==0 ){
                  content+=document.getElementById('model3').innerHTML;
              }else{
                  content+=document.getElementById('model2').innerHTML;
                  content+="<div"+" style='width:100%;height:150px;'"+"></div>";//加空格
              }

          }
      }

      content = content + eprnstr;//加载打印尾
      printStr = printStr+content+"</body></html>";
      let pwin=window.open("Print.htm","print"); //如果是本地测试，需要先新建Print.htm，如果是在域中使用，则不需要
      pwin.document.write(content);
      pwin.document.close();                   //这句很重要，没有就无法实现
      pwin.print();
      window.location.reload();
    },
    start_page(){//上一页
      if( $("#ipt_count").val()==1 ){
          //子表只有一页
          alert("一共只有一页，不存在上一页");
          return;
      }
      if( $("#ipt").val() == 0 ){
          alert("当前页已经是最前一页");
          return;
      }else{
          $("#ipt").val(  $("#ipt").val()-1  );
          let page_number=$("#ipt").val();
          //显示  "model"+$("#ipt").val()，隐藏  "model"+($("#ipt").val()+1)
          document.getElementById("div_model"+page_number ).style.display="";//显示
          page_number++;
          document.getElementById("div_model"+page_number ).style.display="none";//隐藏
      }
    },
    end_page(){//下一页
      let num=$("#ipt_count").val();
      if( $("#ipt_count").val()==1 ){
          //子表只有一页
          alert("一共只有一页，不存在下一页");
          return;
      }
      //如果显示的是model0
      if( $("#ipt").val() == num-1 ){
          alert("当前页已经是最后一页");
          return;
      }else{
          let page_number=$("#ipt").val();
          //显示  "model"+$("#ipt").val()，隐藏  "model"+($("#ipt").val()+1)
          document.getElementById("div_model"+page_number ).style.display="none";//隐藏
          page_number++;
          $("#ipt").val(page_number);
          document.getElementById("div_model"+page_number ).style.display="";//显示
      }
    },
    showDJ(data){//展示单据
            //定义一个数组来存储子表数据
            var  count = 0;
            console.log(data);
            var sss="";
            if(data.WBF==null || data.WBF==""){
                data.WBF = 0;
            }
            if(data.HYFWF==null || data.HYFWF==""){
                data.HYFWF = 0;
            }
            sss+="<br/<br/><h2 style='font-size:24px;font-weight: 600;text-align: center;'>缤 纷 城"+data.NY+"&nbsp;&nbsp;租 赁 通 知 单</h2><br/<br/>"+
            "<table   id=tab_0 width=100% style='border-collapse:collapse;'>"+
                "<tr>"+
                "<td  style='text-align:center;font-size:20px;'   colspan=8 align='center'><b></b></td>"+
                "</tr>"+
                "</table>";

            sss+="<table   id=tab_0 width=100% style='border-collapse:collapse;'>"+
                "<tr>"+
                "<td  style='text-align:right;font-size:15px;'   colspan=8 align='right'><b>单位:元&nbsp;&nbsp;&nbsp;&nbsp;</b></td>"+
                "</tr>"+
                "</table>";

            sss+="<table   id=tab_1 width=100%  style='border-collapse:collapse;font-size: 9pt;'>"+
                "<tr>"+
                "<td align='left' colspan='2' class=class1>合同编号</td>"+
                "<td align='center'>"+data.HTH+"</td>"+
                "</tr>"+
                "<tr>"+
                "<td align='left' colspan='2' class=class1>商户名称</td>"+
                "<td align='center'>"+data.SHMC+"</td>"+
                "</tr>"+
                "<tr>"+
                "<td align='left' colspan='2' class=class1>品牌</td>"+
                "<td align='center'>"+data.PP+"</td>"+
                "</tr>"+
                "<tr>"+
                "<td align='left' colspan='2' class=class1>①、POS机实收金额(含现金及活动优惠)</td>"+
                "<td align='center'>"+data.YSXSE+"</td>"+
                "</tr>"+
                "<tr>"+
                "<td align='center' colspan='2' class=class1>活动优惠总额</td>"
                if(Number(data.HDYHZE) && Number(data.HDYHZE)!=0){
                    sss+= "<td align='center' >"+data.HDYHZE+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss+="</tr>"+
                "<tr>"+
                "<td align='left' colspan='2' class=class1>②、需分摊活动优惠额</td>";
                if(Number(data.XFTHDYHE) && Number(data.XFTHDYHE)!=0){
                    sss+= "<td align='center' >"+data.XFTHDYHE+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss+="</tr>";
                // "<tr>"+
                // "<td align='left' colspan='2' class=class1>合同扣率</td>"+
                // "<td align='center'>"+data.HTKL+"</td>"+
                // "</tr>"+
                // "<tr>"+
                // "<td align='left' colspan='2' class=class1>保底月租金</td>"+
                // "<td align='center'>"+data.BDYZJ+"</td>"+
                // "</tr>"+
                

                if(Number(data.ZZKK) && Number(data.ZZKK)!=0){
                    sss+="<tr>"+
                    // "<td  align='center' style='wclassth:20px;'>1</td>"+
                    "<td align='center' colspan='2' class=class1>正常扣款(租金)</td>"+
                    "<td align='center'>"+data.ZZKK+"</td>"+
                    "</tr>";
                }
                if(Number(data.KKTZ) && Number(data.KKTZ)!=0){
                    sss+="<tr>"+
                    //"<td  align='center'  style='wclassth:20px;'>2</td>"+
                    "<td align='center' colspan='2' class=class1>调整前期正常扣款</td>"+
                    "<td align='center'>"+data.KKTZ+"</td>"+
                    "</tr>";
                }
                if(Number(data.QCJK) && Number(data.QCJK)!=0){
                    sss+="<tr>"+
                    //"<td  align='center'  style='wclassth:20px;'>3</td>"+
                    "<td align='center' colspan='2' class=class1>减免租金</td>"+
                    "<td align='center'>"+data.QCJK+"</td>"+
                    "</tr>";
                }
                if(Number(data.HYFKK) && Number(data.HYFKK)!=0){
                    sss+="<tr>"+
                    //"<td  align='center'  style='wclassth:20px;'>4</td>"+
                    "<td align='center' colspan='2' class=class1>会员储点费</td>"+
                    "<td align='center'>"+data.HYFKK+"</td>"+
                    "</tr>";
                }
                if(Number(data.PPTGF) && Number(data.PPTGF)!=0){
                    sss+="<tr>"+
                    //"<td  align='center'  style='wclassth:20px;'>5</td>"+
                    "<td align='center' colspan='2' class=class1>商品推广费</td>"+
                    "<td align='center'>"+data.PPTGF+"</td>"+
                    "</tr>";
                }
                if(Number(data.JFCE) && Number(data.JFCE)!=0){
                    sss+="<tr>"+
                    //"<td  align='center'  style='wclassth:20px;'>6</td>"+
                    "<td align='center' colspan='2' class=class1>积分加抽额</td>"+
                    "<td align='center'>"+data.JFCE+"</td>"+
                    "</tr>";
                }
                if(Number(data.XFS) && Number(data.XFS)!=0){
                    sss+="<tr>"+
                    //"<td  align='center'  style='wclassth:20px;'>7</td>"+
                    "<td align='center' colspan='2' class=class1>扣消费税</td>"+
                    "<td align='center'>"+data.XFS+"</td>"+
                    "</tr>";
                }
                if(Number(data.DF) && Number(data.DF)!=0){
                    sss+="<tr>"+
                    //"<td  align='center'  style='wclassth:20px;'>8</td>"+
                    "<td align='center' colspan='2' class=class1>"+data.DSQJ+" 电费</td>"+
                    "<td align='center'>"+data.DF+"</td>"+
                    "</tr>";
                }
                if(Number(data.DQSYF) && Number(data.DQSYF)!=0){
                    sss+="<tr>"+
                    //"<td  align='center'  style='wclassth:20px;'>9</td>"+
                    "<td align='center' colspan='2' class=class1>"+data.DSQJ+" 设施设备使用费</td>"+
                    "<td align='center'>"+data.DQSYF+"</td>"+
                    "</tr>";
                }
                if(Number(data.SF) && Number(data.SF)!=0){
                    sss+="<tr>"+
                    //"<td  align='center'  style='wclassth:20px;'>10</td>"+
                    "<td align='center' colspan='2' class=class1>"+data.DSQJ+" 水费</td>"+
                    "<td align='center'>"+data.SF+"</td>"+
                    "</tr>";
                }
                if(Number(data.WSFBT) && Number(data.WSFBT)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>11</td>"+
                    "<td align='center' colspan='2' class=class1>水费补贴</td>"+
                    "<td align='center'>"+data.WSFBT+"</td>"+
                    "</tr>";
                }
                if(Number(data.TDF) && Number(data.TDF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>12</td>"+
                    "<td align='center' colspan='2' class=class1>电费补贴</td>"+
                    "<td align='center'>"+data.TDF+"</td>"+
                    "</tr>";
                }
                if(Number(data.JRKKF) && Number(data.JRKKF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>13</td>"+
                    "<td align='center' colspan='2' class=class1>银行卡手续费</td>"+
                    "<td align='center'>"+data.JRKKF+"</td>"+
                    "</tr>";
                }
                if(Number(data.WYGLF) && Number(data.WYGLF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>14</td>"+
                    "<td align='center' colspan='2' class=class1>物业管理费</td>"+
                    "<td align='center'>"+data.WYGLF+"</td>"+
                    "</tr>";
                }
                if(Number(data.WYGLF_TZ) && Number(data.WYGLF_TZ)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>15</td>"+
                    "<td align='center' colspan='2' class=class1>前期物业管理费调整</td>"+
                    "<td align='center'>"+data.WYGLF_TZ+"</td>"+
                    "</tr>";
                }
                if(Number(data.QCJK_GLF) && Number(data.QCJK_GLF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>16</td>"+
                    "<td align='center' colspan='2' class=class1> 减免物业管理费</td>"+
                    "<td align='center'>"+data.QCJK_GLF+"</td>"+
                    "</tr>";
                }
                if(Number(data.TGF) && Number(data.TGF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>17</td>"+
                    "<td align='center' colspan='2' class=class1>品牌推广费</td>"+
                    "<td align='center'>"+data.TGF+"</td>"+
                    "</tr>";
                }
                if(Number(data.TGFTZ) && Number(data.TGFTZ)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>18</td>"+
                    "<td align='center' colspan='2' class=class1>前期品牌推广费调整</td>"+
                    "<td align='center'>"+data.TGFTZ+"</td>"+
                    "</tr>";
                }
                if(Number(data.QCJK_TGF) && Number(data.QCJK_TGF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>19</td>"+
                    "<td align='center' colspan='2' class=class1>减免品牌推广费</td>"+
                    "<td align='center'>"+data.QCJK_TGF+"</td>"+
                    "</tr>";
                }
                if(Number(data.WBF) && Number(data.WBF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>20</td>"+
                    "<td align='center' colspan='2' class=class1>外摆费用</td>"+
                    "<td align='center'>"+data.WBF+"</td>"+
                    "</tr>";
                }
                if(Number(data.CKF) && Number(data.CKF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>21</td>"+
                    "<td align='center' colspan='2' class=class1>仓库租赁费</td>"+
                    "<td align='center'>"+data.CKF+"</td>"+
                    "</tr>";
                }
                if(Number(data.SYXT_SYF) && Number(data.SYXT_SYF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>22</td>"+
                    "<td align='center' colspan='2' class=class1>收银系统使用费</td>"+
                    "<td align='center'>"+data.SYXT_SYF+"</td>"+
                    "</tr>";
                }
                if(Number(data.HY_FWF) && Number(data.HY_FWF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>23</td>"+
                    "<td align='center' colspan='2' class=class1>会员促销服务费</td>"+
                    "<td align='center'>"+data.HY_FWF+"</td>"+
                    "</tr>";
                }
                if(Number(data.WLF) && Number(data.WLF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>24</td>"+
                    "<td align='center' colspan='2' class=class1>网络费</td>"+
                    "<td align='center'>"+data.WLF+"</td>"+
                    "</tr>";
                }
                if(Number(data.BXF) && Number(data.BXF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>25</td>"+
                    "<td align='center' colspan='2' class=class1>代扣保险费</td>"+
                    "<td align='center'>"+data.BXF+"</td>"+
                    "</tr>";
                }
                if(Number(data.DHF) && Number(data.DHF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>26</td>"+
                    "<td align='center' colspan='2' class=class1>电汇费</td>"+
                    "<td align='center'>"+data.DHF+"</td>"+
                    "</tr>";
                }
                if(Number(data.TM_CDF) && Number(data.TM_CDF)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>27</td>"+
                    "<td align='center' colspan='2' class=class1>特卖场地费</td>"+
                    "<td align='center'>"+data.TM_CDF+"</td>"+
                    "</tr>";
                }
                if(Number(data.QT) && Number(data.QT)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>28</td>"+
                    "<td align='center' colspan='2' class=class1>其他</td>"+
                    "<td align='center'>"+data.QT+"</td>"+
                    "</tr>";
                }
                if(Number(data.WYBZJ) && Number(data.WYBZJ)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>29</td>"+
                    "<td align='center' colspan='2' class=class1>履约保证金</td>"+
                    "<td align='center'>"+data.WYBZJ+"</td>"+
                    "</tr>";
                }
                if(Number(data.SDBZJ) && Number(data.SDBZJ)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>30</td>"+
                    "<td align='center' colspan='2' class=class1>水电保证金</td>"+
                    "<td align='center'>"+data.SDBZJ+"</td>"+
                    "</tr>";
                }
                if(Number(data.SYXT_YJ) && Number(data.SYXT_YJ)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>31</td>"+
                    "<td align='center' colspan='2' class=class1>收银系统押金</td>"+
                    "<td align='center'>"+data.SYXT_YJ+"</td>"+
                    "</tr>";
                }
                if(Number(data.QTYJ) && Number(data.QTYJ)!=0){
                    sss+="<tr>"+
                    //"<td align='center' style='wclassth:20px;'>32</td>"+
                    "<td align='center' colspan='2' class=class1>其他押金</td>"+
                    "<td align='center'>"+data.QTYJ+"</td>"+
                    "</tr>";
                }
                
                sss+="<tr>"+
                "<td align='left' colspan='2' class=class1>③、减：费用及租金合计</td>";//(1-16小项)
                if(Number(data.ZJHJ) && Number(data.ZJHJ)!=0){
                    sss+= "<td align='center' >"+data.ZJHJ+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss+="</tr>"+
                "<tr>"+
                "<td align='left' colspan='2' class=class1>④、减：专柜自收现金营业款</td>";
                if(Number(data.ZG_ZSXJK) && Number(data.ZG_ZSXJK)!=0){
                    sss+= "<td align='center' >"+data.ZG_ZSXJK+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss+="</tr>"+
                "<tr>"+
                "<td align='left' colspan='2' class=class1>⑤、加：我司代收现金营业款</td>";
                if(Number(data.WS_DSXJ) && Number(data.WS_DSXJ)!=0){
                    sss+= "<td align='center' >"+data.WS_DSXJ+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss+="</tr>"+
                "<tr>"+
                "<td align='left' colspan='2' class=class1>⑥、加：已收现金费用</td>";
                if(Number(data.YSXJ) && Number(data.YSXJ)!=0){
                    sss+= "<td align='center' >"+data.YSXJ+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss+="</tr>"+
                "<tr>"+
                "<td align='left' colspan='2' class=class1>应付商户货款（①-②-③-④+⑤+⑥）</td>";
                if(Number(data.GYSHK) && Number(data.GYSHK)!=0){
                    sss+= "<td align='center' >"+data.GYSHK+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss+="</tr>"+
                "<tr>"+
                "<td align='left' colspan='2' class=class1>备注"
                +'<img  src="/fvue/img/seal.png" width="150px" height="40px"/>'
                +"</td>"+
                "<td align='center'>"+data.BZMX+"</td>"+
                "</tr>"+
                "<tr>"+
                "<td align='left' colspan='2' class=class1>提货卡销售开普票金额（重点提示）</td>";
                if(Number(data.THKXSKPJE) && Number(data.THKXSKPJE)!=0){
                    sss+= "<td align='center' >"+data.THKXSKPJE+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss+="</tr>"+
                "<tr>"+
                "<td align='left' colspan='2' class=class1>活动优惠补贴专票金额（重点提示）</td>";
                if(Number(data.HDYHBTZPJE) && Number(data.HDYHBTZPJE)!=0){
                    sss+= "<td align='center' >"+data.HDYHBTZPJE+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss+="</tr>"+
                "<tr>"+
                "<td align='left' colspan='2' class=class1>提示：我司代收营业款（总额）①-②-④+⑤</td>";
                if(Number(data.DSYYK) && Number(data.DSYYK)!=0){
                    sss+= "<td align='center' >"+data.DSYYK+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss+="</tr>";
            $("#model0").append(sss);

            //子表表头
            var sss2= "<table id=tab_3_"+i+" width=100% style='border-collapse:collapse;font-size: 15px;'>";

            var count=1;//子表共有几页
            //console.log(count);
            //设置 计数div 的value 为 count
            $("#ipt_count").val(count);
            $("#div_box").val(data.length);
            for (var i=0;i<count;i++){
                if(i==0){
                    var div_box="<div id=div_model"+i+"></div>";
                    $("#model1").append(div_box);
                }else{
                    var div_box="<div id=div_model"+i+" style='display:none;'></div>";
                    $("#model1").append(div_box);
                }

            }
            //不带分页的表格尾部
            if(true){
                var sss4=
                    "<table id=tab_5 width=100% style='border-collapse:collapse;'>"+
                    "<tr>"+
                    "<td align=right style='font-size:15px;' colspan=><b>上传时间：</b></td>"+
                    "<td style='font-size:15px;' colspan=2><b>"+data.CONFIRM_DATE+"</b></td>"+
                    // "<td align='right' style='font-size:15px;'  colspan=7><b>盖章/按手印：</b></td>"+
                    // "<td align='right' style='font-size:15px;'  colspan=7><b>日期：</b></td>"+
                    "<td align='right' style='font-size:15px;'  colspan=7><b></b></td>"+
                    "</tr>"+
                    "</table></div>"
            }
            //带分页的表格尾部
            var div5="<div class=table_  id=model5 name=model></div>";
            var div6="<div class=table_  id=model6 name=model></div>";
            $("#model2").append(div5);
            $("#model3").append(div6);
            $("#model0").append(sss4);
            $("#tab_0  td").css("width","120px");
            $(".class1").css("width","50%");
            $("#tab_1  td").css("height","25px");
            $("#tab_1 td").css("border","1px solid");
            $("#tab_2  td").css("width","140px");
            $("#tab_2  td").css("height","25px");
            $("#tab_2 td").css("border","1px solid");
            $("#tab_3 td").css("border","1px solid");
            $("#tab_3_1 td").css("border","1px solid");
            $("#tab_4 td").css("border","1px solid");
            $("#tab_5  td").css("width","140px");
            $("#tab_5  td").css("height","25px");
            $("td").css("font-size","16px");


    },
    changeMoneyToChinese(money){
      let cnNums = new Array("零","壹","贰","叁","肆","伍","陆","柒","捌","玖"); //汉字的数字
      let cnIntRadice = new Array("","拾","佰","仟"); //基本单位
      let cnIntUnits = new Array("","万","亿","兆"); //对应整数部分扩展单位
      let cnDecUnits = new Array("角","分","毫","厘"); //对应小数部分单位
      let cnInteger = "整"; //整数金额时后面跟的字符
      let cnIntLast = "元"; //整型完以后的单位
      let maxNum = 999999999999999.9999; //最大处理的数字

      let IntegerNum; //金额整数部分
      let DecimalNum; //金额小数部分
      let ChineseStr=""; //输出的中文金额字符串
      let parts; //分离金额后用的数组，预定义
      if( money === "" ){
          return "";
      }
      money = parseFloat(money);
      if( money >= maxNum ){
          $.alert('超出最大处理数字');
          return "";
      }
      if( money==0 ){
          ChineseStr = cnNums[0]+cnIntLast+cnInteger;
          return ChineseStr;
      }
      money = money.toString(); //转换为字符串
      if( money.indexOf(".") == -1 ){
          IntegerNum = money;
          DecimalNum = '';
      }else{
          parts = money.split(".");
          IntegerNum = parts[0];
          DecimalNum = parts[1].substr(0,4);
      }
      if( parseInt(IntegerNum,10) > 0 ){//获取整型部分转换
          let zeroCount = 0;
          let IntLen = IntegerNum.length;
          for(let i=0;i<IntLen;i++ ){
              let n = IntegerNum.substr(i,1);
              let p = IntLen - i - 1;
              let q = p / 4;
              let m = p % 4;
              if( n == "0" ){
                  zeroCount++;
              }else{
                  if( zeroCount > 0 ){
                      ChineseStr += cnNums[0];
                  }
                  zeroCount = 0; //归零
                  ChineseStr += cnNums[parseInt(n)]+cnIntRadice[m];
              }
              if( m==0 && zeroCount<4 ){
                  ChineseStr += cnIntUnits[q];
              }
          }
          ChineseStr += cnIntLast;
          //整型部分处理完毕
      }
      if( DecimalNum!= '' ){//小数部分
          let decLen = DecimalNum.length;
          for(let i=0; i<decLen; i++ ){
              let n = DecimalNum.substr(i,1);
              if( n != '0' ){
                  ChineseStr += cnNums[Number(n)]+cnDecUnits[i];
              }
          }
      }
      if( ChineseStr == '' ){
          //ChineseStr += cnNums[0]+cnIntLast+cnInteger;
          ChineseStr += cnNums[0]+cnIntLast;
      }
      if( money.substring(money.length-2,money.length-1)===0   ){
          ChineseStr+='整';
      }
      return ChineseStr;
    }
  },
  mounted(){
    this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/searchZLTZD?GHDWDM="+this.user.account.replaceAll("SZHY","")+"&DJBH="+this.HTH+"&NY="+this.NY).then(resp=>{
      let ipt="<input type="+"hidden"+" id="+"ipt"+" value="+"0"+">";    //这个input输入框也要隐藏，他的  value 代表是第几页（0代表第一页，默认为0）
      let ipt_count="<input"+" id=ipt_count"+" value="+"0"+" type="+"hidden"+">";//需要隐藏的input ,这个 input 的value是 代表费用子表的记录页数
      let div_hidden="<div"+" id=model_hidden"+"></div>";//需要隐藏的div
      let div_box="<div"+" id="+"div_box"+" value="+"0"+"></div>"; //子表记录条数
      $(".mini-grid").append(ipt);
      $(".mini-grid").append(ipt_count);
      $(".mini-grid").append(div_hidden);
      $(".mini-grid").append(div_box);
      //获取页面跳转时传递的参数
      //开票确认单也要分页
      //默认显示第一页
      let div1="<div"+" class="+"preview"+"  id=model0"+" name="+"model"+"></div>";  //存放页面头
      let div2="<div"+" class="+"preview"+"  id=model1"+" name="+"model"+"></div>";  //存放子表
      let div3="<div"+" class="+"preview"+"  id=model2"+" name="+"model"+"></div>";  //存放页面尾
      let div4="<div"+" class="+"preview"+"  id=model3"+" name="+"model"+" style='display: none;'"+"></div>";  //存放  带有分页标识的表格 (默认隐藏)
      $(".mini-grid").append(div1);
      $(".mini-grid").append(div2);
      $(".mini-grid").append(div3);
      $(".mini-grid").append(div4);
      this.showDJ(resp.data.data);
    });
  }
};
</script>

<style lang="scss" scoped>

</style>